/* Named so a page cross-fade keeps the closing sheet above the tab bar, which is also named, not under it with the old page. */
.scrim { position: fixed; inset: 0; z-index: 40; background: var(--scrim); view-transition-name: sheet-scrim; }
.sheet { position: fixed; left: 0; right: 0; bottom: 0; z-index: 41; display: flex; flex-direction: column; background: var(--paper); border-top: 2px solid var(--ink); padding: 0 16px env(safe-area-inset-bottom); view-transition-name: sheet; }
.sheet[data-fill='true'] { height: calc(100dvh - 58px); }
.grabber { display: flex; align-items: flex-end; justify-content: center; height: 20px; flex: none; }
.handle { width: 40px; height: 4px; background: var(--ink-25); }
@media (min-width: 640px) {
  .sheet { display: contents; }
  .scrim, .grabber { display: none; }
}
